import appConfig from "../constants/config";
import { postApiAxios } from "./apiClient";
import { getObjectRequester } from "./localStorage/localStorage";

function toAmount(value: any): number {
    if (value == null || value === "") return NaN;
    return parseFloat(value.toString().replace(/,/g, ""));
}

const isNullOrEmpty = (value: any): boolean => value == null || value == '' || value == undefined;

// Begin, Saber, 20260821, INC-1024128 - Port legacy's BindZeroAttach() (AttachmentControl.js).
// checkAndAllowZeroAttach() below only ever *reads* localStorage["ByAttachmentCondition"] -
// nothing in the PWA was actually calling /api/getAndCheckCondition to populate it, so the
// ByPass list was always null and allowzeroattach was always forced to 0 (attachment always
// required), even for subcategories with a "Not Exceed"/"Exceed"/"Not Needed" bypass condition
// configured (e.g. Other employee benefits > Flexible commuting expenses). This fetches and
// caches the same condition list legacy loads on every claim-detail page load.
export async function bindZeroAttach(): Promise<void> {
    try {
        const objRequestor = getObjectRequester();
        if (isNullOrEmpty(objRequestor)) {
            return;
        }
        const param = {
            company_code: objRequestor.company_code,
            country_code: objRequestor.country_code,
        };
        const url = `${appConfig.connectionString.ws}/api/getAndCheckCondition`;
        const result = await postApiAxios(url, param);
        if (!isNullOrEmpty(result) && result.length > 0) {
            localStorage.setItem("ByAttachmentCondition", JSON.stringify(result));
        }
    } catch (error) {
        console.error("bindZeroAttach error:", error);
    }
}
// End, Saber, 20260821

export function checkAndAllowZeroAttach(i: number | undefined, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, currentOnChangeInput?: any) {

    let tempcat_val = inputValues[`ddlCategory${i}`];
    // Begin,Saber,20261007,INC-1016292 - use the value just selected. The input snapshot can still
    // be empty when transport type or phone type changes, which skips the JP public-transport bypass.
    let transportdetail_exists = !isNullOrEmpty(currentOnChangeInput) && inputValues[`ddlCategory${i}`] == 4
        ? currentOnChangeInput
        : inputValues[`ddlTransportType${i}`];
    let phonedetail_exists = !isNullOrEmpty(currentOnChangeInput) && inputValues[`ddlCategory${i}`] == 26
        ? currentOnChangeInput
        : inputValues[`ddlPhoneType${i}`];
    let Cur = inputValues[`txtExchangeAmount${i}`];
    // End,Saber,20261007,INC-1016292
    let ByPass = !isNullOrEmpty(localStorage.getItem("ByAttachmentCondition")) ? JSON.parse(localStorage.getItem("ByAttachmentCondition")!) : null;

    let allowzeroattach = 0

    let isvalid = true;

    if (tempcat_val == null || tempcat_val == undefined) {
        isvalid = false;
    }

    if (tempcat_val == 4) {
        if (transportdetail_exists == null || transportdetail_exists == undefined) {
            isvalid = false;
        }
    }

    if (tempcat_val == 26) {
        if (phonedetail_exists == null || phonedetail_exists == undefined) {
            isvalid = false;
        }
    }

    if (Cur == null || Cur == undefined || Cur <= 0) {
        isvalid = false;
    }

    if (tempcat_val == 48 && Cur < 1) {
        allowzeroattach = 1;
    }

    if (isvalid) {

        //Set Control checking
        let checktransport = 0;
        let checkphone = 0;
        let checknondetail = 0;

        if (transportdetail_exists != null && transportdetail_exists != undefined) {
            checktransport = 1;
        } else if (phonedetail_exists != null && phonedetail_exists != undefined) {
            checkphone = 1;
        } else {
            checknondetail = 1;
        }

        if (!isNullOrEmpty(ByPass) && ByPass.length > 0) {
            for (let ind = 0; ind < ByPass.length; ind++) {
                //Check for Non detail claim
                if (checknondetail == 1) {
                    if (ByPass[ind].sub_category_id == tempcat_val) {
                        if (ByPass[ind].condition == "Not Exceed") {
                            if (toAmount(inputValues[`txtClaimAmount${i}`]) <= toAmount(ByPass[ind].condition_value)) {
                                allowzeroattach = 1
                            }
                        } else if (ByPass[ind].condition == "Exceed") {
                            if (toAmount(inputValues[`txtClaimAmount${i}`]) > toAmount(ByPass[ind].condition_value)) {
                                allowzeroattach = 1
                            }
                        } else if (ByPass[ind].condition == "Not Needed") {
                            allowzeroattach = 1
                        }
                    }
                }

                //Check For transport
                if (checktransport == 1) {
                    if (ByPass[ind].sub_category_id == tempcat_val) {
                        if (ByPass[ind].detail_id == transportdetail_exists) {
                            if (ByPass[ind].condition == "Not Exceed") {
                                // Begin,Saber,20261007,INC-1016292 - JP public transport: receipt not required at JPY 3000 or less.
                                // String compare ("3000" <= "3000.00") is false, so the attachment error stayed.
                                if (toAmount(inputValues[`txtClaimAmount${i}`]) <= toAmount(ByPass[ind].condition_value)) {
                                    allowzeroattach = 1
                                }
                                // End,Saber,20261007,INC-1016292
                            } else if (ByPass[ind].condition == "Exceed") {
                                if (toAmount(inputValues[`txtClaimAmount${i}`]) > toAmount(ByPass[ind].condition_value)) {
                                    allowzeroattach = 1
                                }
                            } else if (ByPass[ind].condition == "Not Needed") {
                                allowzeroattach = 1
                            }
                        }
                    }
                }

                //Check For Phone
                if (checkphone == 1) {
                    if (ByPass[ind].sub_category_id == tempcat_val) {
                        if (ByPass[ind].detail_id == phonedetail_exists) {
                            if (ByPass[ind].condition == "Not Exceed") {
                                if (toAmount(inputValues[`txtClaimAmount${i}`]) <= toAmount(ByPass[ind].condition_value)) {
                                    allowzeroattach = 1
                                }
                            } else if (ByPass[ind].condition == "Exceed") {
                                if (toAmount(inputValues[`txtClaimAmount${i}`]) > toAmount(ByPass[ind].condition_value)) {
                                    allowzeroattach = 1
                                }
                            } else if (ByPass[ind].condition == "Not Needed") {
                                allowzeroattach = 1
                            }
                        }
                    }
                }
            }
        }
    }
    handleInputChange("attachmentAllowZeroAttach", allowzeroattach);
    handleInputChange("attachmentFormValid", isvalid);
    return allowzeroattach;
}